import { NavLink } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { CLOUD_LOGO, resolveAsset } from "@/lib/brand";

export function Sidebar({ navItems, isClient, user, onNavigate }) {
  return (
    <div className="flex h-full flex-col" style={{ background: "var(--cp-sidebar)" }}>
      <div className="flex flex-col justify-center gap-1 px-5 h-16 border-b border-slate-200 bg-white">
        <img src={CLOUD_LOGO} alt="CloudPoweredIT" className="h-7 w-auto max-w-[180px] object-contain object-left" />
        <p className="text-[10px] uppercase tracking-[0.18em] text-[#F7941E]">Client Portal</p>
      </div>
      <nav className="flex-1 px-3 py-5 space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={onNavigate}
            data-testid={`nav-${item.label.toLowerCase().replace(/ /g, "-")}`}
            className={({ isActive }) =>
              `group flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-all duration-200 ${
                isActive ? "bg-white/10 text-white font-medium" : "text-slate-400 hover:text-white hover:bg-white/5"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <item.icon size={18} style={isActive ? { color: "var(--tenant-primary)" } : {}} />
                <span>{item.label}</span>
                {isActive && <ChevronRight size={14} className="ml-auto text-slate-500" />}
              </>
            )}
          </NavLink>
        ))}
      </nav>
      {isClient && user.client && (
        <div className="mx-3 mb-4 rounded-md bg-white/5 p-3 flex items-center gap-3">
          {user.client.logo_url ? (
            <img src={resolveAsset(user.client.logo_url)} alt="" className="h-9 w-9 rounded object-contain bg-white/90 p-0.5" />
          ) : (
            <div className="h-9 w-9 rounded tenant-accent-bg" />
          )}
          <div className="leading-tight overflow-hidden">
            <p className="text-white text-xs font-medium truncate">{user.client.name}</p>
            <p className="text-[10px] text-slate-400 truncate">{user.client.plan}</p>
          </div>
        </div>
      )}
      <div className="px-3 pb-4 text-[10px] text-slate-500 uppercase tracking-wider">
        Powered by CloudPoweredIT
      </div>
    </div>
  );
}
